<button
  *ngIf="isVisible"
  class="scroll-to-top-btn"
  (click)="scrollToTop()"
  [attr.aria-label]="'Scroll to top'"
  title="Scroll to top">
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>
